import { Box } from '@mui/material';
import { Typography } from '@portals/core/src/components/Typography/Typography';
import { theme } from '@portals/core/src/themes/immobilien/main';
import { EstateDetail } from '@portals/sip-client-data/src/general/ApiClientTypes';
import { getFixedT } from 'i18next';
import React from 'react';

import { EstateImage } from '../../../../../../EstateImage/EstateImage';
import { GalleryFilterType } from '../../../../../../Gallery';
import { getFirstGalleryItemByType } from '../../../../../HeadSection/HeadSection.utils';
import { getImageObject } from '../../../../../HeadSection/ImageSection/ImageSection.utils';
import { getStyles } from '../../EstateContact.styles';

interface EstateTeaserSectionProps {
  estate: EstateDetail;
}

const t = getFixedT(null, 'core-immobilien');

export const EstateTeaserSection = ({ estate }: EstateTeaserSectionProps): React.ReactElement => {
  const styles = getStyles(theme);

  return (
    <Box sx={styles.teaserContainer}>
      <EstateImage
        imageObject={getImageObject(
          getFirstGalleryItemByType(estate.images, GalleryFilterType.IMAGE),
          'm',
          estate.seo.title
        )}
        imageStyle={styles.teaserImage as React.CSSProperties}
        sx={styles.teaserImageContainer}
      />
      <Box>
        <Typography variant="h6">{estate.subtitle}</Typography>
        <Typography className="estate-contact-form-broker" variant="h5">
          {estate.title}
        </Typography>
        <Typography className="estate-contact-form-institute" variant="body2">
          {t('detailPage.objectNumber', {
            id: estate.id,
            externId: estate.externId,
            interpolation: { escapeValue: false },
          })}
        </Typography>
      </Box>
    </Box>
  );
};

EstateTeaserSection.displayName = 'EstateTeaserSection';
